export enum ToolCallName {
    BlockSuggest = "blocks.suggest",
}

/** The list of active tool call names with displayable content */
export const ActiveToolCallNames = [ToolCallName.BlockSuggest];
